<div class="load-events">
    <div class="ibox float-e-margins">
        <div class="ibox-title border-primary no-padding">
            <div class="load-events-title" (click)="expand()">
                <i class="load-events-title-icon fa fa-clock"></i>

                <span class="load-events-title-text" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.events.title'}]"></span>

                <i class="load-events-title-expand fa" [ngClass]="{ 'fa-minus': expanded, 'fa-plus': !expanded }"></i>
            </div>
        </div>

        <div class="ibox-content no-padding" *ngIf="expanded">

            <div *ngFor="let event of events" class="load-event">
                <ng-container *ngIf="event.type">
                    <span class="load-event-date" [title]="event.happenedAt | fullDate">{{ event.happenedAt | dateDiffFromNow | async }}</span>
                    <div class="load-event-type">
                        <label class="label" [ngClass]="{ 'label-success': event.status === EventStatus.SUCCEED, 'label-danger': event.status === EventStatus.FAILED, 'label-warning': event.status === EventStatus.PARTIALLY_SUCCEED }"
                                             [i18n]="[{target: 'innerHTML', key: event.type.translationKey}]">
                        </label>
                    </div>

                    <ng-container [ngSwitch]="event.type">
                        <app-load-event-vehicle-assignation [event]="event" *ngSwitchCase="EventTypes.VEHICLE_ASSIGNATION">
                        </app-load-event-vehicle-assignation>
                        <app-load-event-status-update [event]="event" *ngSwitchCase="EventTypes.STATUS_UPDATE">
                        </app-load-event-status-update>
                        <app-load-event-eta-update [event]="event" *ngSwitchCase="EventTypes.ETA_UPDATE">
                        </app-load-event-eta-update>
                        <app-load-event-pod-upload [event]="event" *ngSwitchCase="EventTypes.POD_UPLOAD">
                        </app-load-event-pod-upload>
                        <app-load-event-picture-upload [event]="event" *ngSwitchCase="EventTypes.PICTURE_UPLOAD">
                        </app-load-event-picture-upload>
                        <app-load-event-checkin [event]="event" *ngSwitchCase="EventTypes.CHECK_IN">
                        </app-load-event-checkin>
                        <app-load-event-checkout [event]="event" *ngSwitchCase="EventTypes.CHECK_OUT">
                        </app-load-event-checkout>
                        <app-load-event-note-creation [event]="event" *ngSwitchCase="EventTypes.NOTE_CREATION">
                        </app-load-event-note-creation>
                        <app-load-event-manual-item-added [event]="event" *ngSwitchCase="EventTypes.MANUAL_ITEM_ADDED">
                        </app-load-event-manual-item-added>
                        <app-load-event-cancel-checkin [event]="event" *ngSwitchCase="EventTypes.CANCEL_CHECK_IN">
                        </app-load-event-cancel-checkin>

                        <ng-container *ngSwitchDefault>
                            <span class="load-event-value" *ngIf="event.type.showOldValue && event.oldValue">
                                {{ event.oldValue }}
                            </span>
                            <span class="load-event-empty-value" *ngIf="event.type.showOldValue && !event.oldValue"
                                  [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.events.empty-value'}]"></span>

                            <span class="load-event-values-separator" *ngIf="event.type.showOldValue && event.type.showNewValue">
                                <i class="fa fa-arrow-right"></i>
                            </span>

                            <span class="load-event-value" *ngIf="event.type.showNewValue && event.newValue">
                                {{ event.newValue }}
                            </span>
                            <span class="load-event-empty-value" *ngIf="event.type.showNewValue && !event.newValue"
                                  [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.events.empty-value'}]">
                            </span>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="event.errorMessage">
                        {{ event.errorMessage }}
                    </ng-container>
                </ng-container>
            </div>

        </div>
    </div>
</div>
